import TroubleshootRoundedIcon from '@mui/icons-material/TroubleshootRounded';
import { Box, Fade, Typography } from '@mui/material';

interface NoDataFoundProps {
  message: string;
}

const NoDataFound = ({ message } : NoDataFoundProps) => {
  return (
    <Fade in={true}>
      <Box sx={{
        display: 'grid',
        justifyItems: 'center',
        alignContent: 'center',
        height: '100%',
      }}>
        <TroubleshootRoundedIcon sx={{ fontSize:'120px', color: '#E7E7E7' }} />
          
        <Typography sx={{
          fontSize: '20px',
          color: '#878787',
        }}
        >{message}</Typography>
      </Box>
    </Fade>
  );
};

export default NoDataFound;